import { DeliveryPreferenceType } from '@order/graphql';

export const ADDRESS_TYPE = {
  HOME: 'home',
  WORK: 'work',
  CUSTOM: 'custom',
};

export const DELIVERY_PREFERENCE = {
  LEAVE_AT_DOOR: 'LEAVE_AT_DOOR',
  DOOR: 'DOOR',
  CURBSIDE: 'CURBSIDE',
};

export const defaultAddressForm = {
  name: '',
  street: '',
  secondaryStreet: '',
  city: '',
  zipCode: '',
  state: '',
  country: '',
  googlePlaceId: '',
  latitude: 0,
  longitude: 0,
  notes: '',
  deliveryPreference: DeliveryPreferenceType.LeaveAtDoor,
};
